import ApiService, { ApiArguments } from '@/api/api_service';
import {
  CallFeedbackSettingApi,
  CallFeedbackSettingApiPutCallFeedbackSettingRequest,
  CallFeedbackSettingBody,
} from '@/api/openapi';

export class CallFeedbackSettingApiService extends ApiService {
  api = new CallFeedbackSettingApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getCallFeedbackSetting(
    apiArguments?: ApiArguments<undefined>,
  ) {
    return this.checkResponse<CallFeedbackSettingBody>(
      this.api.getCallFeedbackSetting(apiArguments?.options),
      apiArguments?.errorHandlers,
    );
  }

  async putCallFeedbackSetting({
    request,
    options,
    errorHandlers,
  }: ApiArguments<CallFeedbackSettingApiPutCallFeedbackSettingRequest>) {
    return this.checkResponse<void>(
      this.api.putCallFeedbackSetting(request, options),
      errorHandlers,
    );
  }
}
